// extracted by mini-css-extract-plugin
export default {"toggleBtn":"Footer_toggleBtn__O3Aiw","themeIcon":"Footer_themeIcon__8jlEN"};